import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import Tooltip from 'react-tooltip'
import cx from 'classnames'
import Link from 'valuelink'
import FileBase64 from 'react-file-base64'

import Box from 'components/layout/Box/Box'
import Input from 'components/form/Input/Input'

import s from './FileInput.scss'

import helpImage from './images/help.svg'


class FileInput extends PureComponent {

  state = {
    fileName: '',
  }

  componentDidMount() {
    const { setOnDone } = this.props

    if (typeof setOnDone === 'function') {
      console.log('set on done')
      setOnDone(this.loadFile)
    }
  }

  componentWillReceiveProps({ valueLink }) {
    const { valueLink: oldValueLink } = this.props

    if (!valueLink.value && oldValueLink.value) {
      this.setState({
        fileName: '',
      })
    }
  }

  loadFile = ({ base64, name }) => {
    const { valueLink, onChange } = this.props

    console.log('load file')

    valueLink.set(base64)

    this.setState({
      fileName: name,
    })

    if (typeof onChange === 'function') {
      onChange(base64)
    }
  }

  render() {
    const { className, inputWrapperClassName, textInputClassName, placeholder, type, label, help, valueLink, withImage, onClick } = this.props

    const _valueLink = Link.state(this, 'fileName')
    _valueLink.error = valueLink.error

    return (
      <div className={className}>
        {
          Boolean(help) && (
            <Tooltip className={s.tooltip} id={`tip${label}`} effect="solid" place="top">
              <div dangerouslySetInnerHTML={{ __html: help }}/>
            </Tooltip>
          )
        }
        <div className={s.label}>
          {label}
          {
            Boolean(help) && (
              <img
                className={s.help}
                src={helpImage}
                data-tip
                data-for={`tip${label}`}
              />
            )
          }
        </div>
        <div className={cx(s.inputWrapper, inputWrapperClassName, { [s.error]: Boolean(_valueLink.error) })}>
          <div className={s.fileInput} onClick={onClick}>
            <FileBase64 onDone={this.loadFile} />
          </div>
          <Input
            className={textInputClassName}
            {...{ valueLink: _valueLink, type, placeholder, placeholderClassName: s.placeholder }}
            accept="image/*"
          />
        </div>
        {
          Boolean(withImage && valueLink.value) && (
            <Box pt="sm">
              <img className={s.image} src={valueLink.value} />
            </Box>
          )
        }
      </div>
    )
  }
}


export default FileInput
